var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nivel" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-4 mb-3 mb-lg-0" }, [
        _c(
          "p",
          { staticClass: "nivel-regra" },
          [
            _vm._v("\n        O nível é definido pelo "),
            _c("b", [_vm._v("valor total faturado")]),
            _vm._v(" de " + _vm._s(_vm.periodo)),
            _vm.dados.meses_minimo
              ? [
                  _vm._v(",\n        com faturamento em pelo menos "),
                  _c("b", [_vm._v(_vm._s(_vm.dados.meses_minimo))]),
                  _vm._v(" dos " + _vm._s(_vm.dados.meses.length) + " meses")
                ]
              : _vm._e(),
            _vm._v(".\n      ")
          ],
          2
        ),
        _vm._v(" "),
        _vm.meu
          ? _c(
              "div",
              {
                staticClass: "nivel-meu",
                class: "nivel-meu--" + _vm.meu.estado
              },
              [
                _c("div", { staticClass: "nivel-meu-topo" }, [
                  _c("span", { staticClass: "nivel-meu-rotulo" }, [
                    _vm._v("Seu progresso")
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "nivel-selo",
                      class: "nivel-selo--" + _vm.meu.nivel
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.meu.nivel ? "Nível " + _vm.meu.nivel : "Sem nível"
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "nivel-meu-total" }, [
                  _vm._v(_vm._s(_vm.moeda(_vm.meu.valor_total)))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nivel-barra nivel-barra--grande" },
                  [
                    _c("div", {
                      staticClass: "nivel-barra-cheia",
                      class: "nivel-fundo--" + _vm.meu.nivel,
                      style: { width: _vm.pct(_vm.meu.valor_total) + "%" }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dados.niveis, function(n, i) {
                      return _c("span", {
                        key: i,
                        staticClass: "nivel-marca",
                        style: { left: _vm.pct(n.total) + "%" },
                        attrs: { title: n.nome + ": " + _vm.moeda(n.total) }
                      })
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nivel-meses" },
                  _vm._l(_vm.dados.meses, function(mes, i) {
                    return _c(
                      "span",
                      {
                        key: mes,
                        staticClass: "nivel-mes",
                        class: {
                          "nivel-mes--ok": (_vm.meu.valores_mes[i] || 0) > 0
                        }
                      },
                      [
                        _vm._v("\n            " + _vm._s(mes) + " "),
                        _c("b", [
                          _vm._v(_vm._s(_vm.moeda(_vm.meu.valores_mes[i] || 0)))
                        ])
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.meu.brinde
                  ? _c("div", [
                      _c("i", { staticClass: "fas fa-gift mr-1" }),
                      _vm._v(_vm._s(_vm.meu.brinde))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("small", { staticClass: "d-block text-muted" }, [
                  _vm._v(_vm._s(_vm.meu.proximo || _vm.meu.situacao))
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nivel-niveis" },
          [
            _c("div", { staticClass: "nivel-niveis-titulo" }, [
              _vm._v("Níveis")
            ]),
            _vm._v(" "),
            _vm._l(_vm.dados.niveis, function(n, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "nivel-item",
                  class: "nivel-borda--" + (i + 1)
                },
                [
                  _c("div", { staticClass: "nivel-item-topo" }, [
                    _c("span", { staticClass: "nivel-item-nome" }, [
                      _vm._v(_vm._s(n.nome))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "nivel-item-valor" }, [
                      _vm._v(_vm._s(_vm.moeda(n.total)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nivel-item-brinde" }, [
                    _vm._v(_vm._s(n.brinde))
                  ]),
                  _vm._v(" "),
                  _vm.dados.rede.length
                    ? _c("div", { staticClass: "nivel-item-qtd" }, [
                        _c("b", [_vm._v(_vm._s(_vm.porNivel[i + 1] || 0))]),
                        _vm._v(" da sua rede\n          ")
                      ])
                    : _vm._e()
                ]
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-8" },
        [
          _vm.dados.rede.length
            ? [
                _c(
                  "div",
                  { staticClass: "nivel-resumo" },
                  [
                    _vm._l(_vm.filtros, function(f) {
                      return _c(
                        "button",
                        {
                          key: f.chave,
                          staticClass: "nivel-filtro",
                          class: [
                            "nivel-filtro--" + f.chave,
                            { "nivel-filtro--ativo": _vm.filtro === f.chave }
                          ],
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.filtro = f.chave
                            }
                          }
                        },
                        [
                          _vm._v("\n            " + _vm._s(f.rotulo) + " "),
                          _c("b", [_vm._v(_vm._s(f.qtd))])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "nivel-busca",
                      attrs: {
                        size: "sm",
                        placeholder: "Buscar revendedora ou cidade"
                      },
                      model: {
                        value: _vm.busca,
                        callback: function($$v) {
                          _vm.busca = $$v
                        },
                        expression: "busca"
                      }
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "nivel-lista" }, [
                  _c("table", { staticClass: "table table-sm mb-0" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", [_vm._v("Revendedora")]),
                          _vm._v(" "),
                          _vm._l(_vm.dados.meses, function(mes) {
                            return _c(
                              "th",
                              {
                                key: mes,
                                staticClass: "text-right d-none d-lg-table-cell"
                              },
                              [_vm._v(_vm._s(mes))]
                            )
                          }),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-right" }, [
                            _vm._v("Total")
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Nível / próximo")])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.redeFiltrada, function(item) {
                          return _c(
                            "tr",
                            { key: item.id },
                            [
                              _c("td", [
                                _c("div", { staticClass: "nivel-nome" }, [
                                  _vm._v(_vm._s(item.nome))
                                ]),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(item.cidade) + "/" + _vm._s(item.uf)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.dados.meses, function(mes, i) {
                                return _c(
                                  "td",
                                  {
                                    key: mes,
                                    staticClass:
                                      "text-right d-none d-lg-table-cell nivel-valor-mes",
                                    class: {
                                      "text-muted": !(item.valores_mes[i] > 0)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.moeda(item.valores_mes[i] || 0)
                                      )
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-right nivel-total" },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.moeda(item.valor_total)))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "nivel-barra" }, [
                                    _c("div", {
                                      staticClass: "nivel-barra-cheia",
                                      class: "nivel-fundo--" + item.nivel,
                                      style: {
                                        width: _vm.pct(item.valor_total) + "%"
                                      }
                                    })
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "nivel-selo",
                                    class: "nivel-selo--" + item.nivel
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.nivel
                                          ? "Nível " + item.nivel
                                          : _vm.semNivel(item)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                item.brinde
                                  ? _c(
                                      "small",
                                      { staticClass: "nivel-brinde" },
                                      [_vm._v(_vm._s(item.brinde))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-muted" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.nivel
                                          ? item.proximo
                                          : item.situacao
                                      )
                                    )
                                  ]
                                )
                              ])
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        !_vm.redeFiltrada.length
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center text-muted py-3",
                                  attrs: { colspan: _vm.dados.meses.length + 3 }
                                },
                                [_vm._v("Nenhuma revendedora encontrada.")]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              ]
            : _c("p", { staticClass: "text-muted" }, [
                _vm._v("Nenhuma revendedora da sua rede participando ainda.")
              ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24a0b7ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a0b7ea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/NivelHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-24a0b7ea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/NivelHome.vue
// module chunks = 2